<template>
  <RevSkipToContent
    to="#skip-to-content-wrapper"
    :to-anchor-id="anchorId"
    @click="scrollTo(anchorId)"
  >
    {{ i18n(translations.skipToContent) }}
  </RevSkipToContent>

  <main id="main-content" v-bind="$attrs">
    <slot />
  </main>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevSkipToContent } from '@ds/components/SkipToContent'

import translations from './TheMainContent.translations'

defineOptions({
  inheritAttrs: false,
})

const i18n = useI18n()

const anchorId = '#main-content'

function scrollTo(hash: string) {
  // We need to append the hash to the location
  // eslint-disable-next-line no-restricted-globals
  location.hash = hash
}
</script>
